import {Component, EventEmitter, HostListener, Input, OnChanges, Output} from '@angular/core';
import {IconComponent} from "../icon/icon.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-image-preview-modal',
    imports: [
        IconComponent,
        TranslateModule
    ],
    templateUrl: './image-preview-modal.component.html',
    styleUrl: './image-preview-modal.component.scss'
})
export class ImagePreviewModalComponent implements OnChanges {
    @Input() imageUrl: string | null = null;
    @Input() imageName: string = '';
    @Output() closed = new EventEmitter<void>();

    protected zoomLevel = 1;
    protected panX = 0;
    protected panY = 0;
    protected isDragging = false;

    private dragStartX = 0;
    private dragStartY = 0;
    private panStartX = 0;
    private panStartY = 0;

    get zoomTransform(): string {
        return `scale(${this.zoomLevel}) translate(${this.panX / this.zoomLevel}px, ${this.panY / this.zoomLevel}px)`;
    }

    get zoomLabel(): string {
        return `${Math.round(this.zoomLevel * 10) / 10}×`;
    }

    ngOnChanges(): void {
        this.resetZoom();
    }

    @HostListener('document:keydown.escape')
    onEscapeKey(): void {
        this.close();
    }

    close(): void {
        this.resetZoom();
        this.closed.emit();
    }

    onBackdropClick(event: MouseEvent): void {
        if (event.target === event.currentTarget) {
            this.close();
        }
    }

    onContentClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    protected zoomIn(): void {
        this.zoomLevel = Math.min(+(this.zoomLevel + 0.5).toFixed(1), 4);
    }

    protected zoomOut(): void {
        this.zoomLevel = Math.max(+(this.zoomLevel - 0.5).toFixed(1), 1);
        if (this.zoomLevel === 1) { this.panX = 0; this.panY = 0; }
    }

    protected resetZoom(): void {
        this.zoomLevel = 1;
        this.panX = 0;
        this.panY = 0;
    }

    protected onWheel(e: WheelEvent): void {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.1 : -0.1;
        const next = Math.min(Math.max(+(this.zoomLevel + delta).toFixed(2), 1), 4);
        if (next === 1) { this.panX = 0; this.panY = 0; }
        this.zoomLevel = next;
    }

    protected onDragStart(e: MouseEvent): void {
        if (this.zoomLevel <= 1) return;
        this.isDragging = true;
        this.dragStartX = e.clientX;
        this.dragStartY = e.clientY;
        this.panStartX = this.panX;
        this.panStartY = this.panY;
        e.preventDefault();
    }

    protected onDragMove(e: MouseEvent): void {
        if (!this.isDragging) return;
        this.panX = this.panStartX + (e.clientX - this.dragStartX);
        this.panY = this.panStartY + (e.clientY - this.dragStartY);
    }

    protected onDragEnd(): void {
        this.isDragging = false;
    }
}
